import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'find',
  standalone: true
})
export class FindPipe implements PipeTransform {
  transform(items: any[], field: string, value: any): any {
    if (!items || !field || value === undefined) return null;
    return items.find(item => item[field] === value);
  }
}